// style-utils.js
import React from 'react';
import { css } from 'styled-components';

import { breakpoints } from './breakpoints';

// Prevent PropType warning by removing unwanted props from a component
export const componentWithoutProps = (Component, ignoreProps = []) => (props) => {
  const filteredProps = { ...props };
  ignoreProps.forEach(prop => {
    if (prop in filteredProps) {
      delete filteredProps[prop];
    }
  });

  return (
     <Component {...filteredProps} />
  );
};

export const getStyle = (map, fallback) => props => {
  const keysFromProps = Object.keys(map).filter(
    key => props[key] !== undefined
  );
  const keyFromProps = keysFromProps[0];
  if (map[keyFromProps]) {
    return map[keyFromProps];
  }
  if (fallback) {
    if (props[fallback] && map[props[fallback]]) {
      return map[props[fallback]];
    }
  }
  return undefined;
};

export const boolStyle = (key, value) => props => {
  return props[key] ? value : null;
};

const getMediaBreakpoints = () => {
  const media = {};

  Object.keys(breakpoints).forEach((breakpoint) => {
    media[breakpoint] = (...args) => css`
      @media ${breakpoints[breakpoint]} {
        ${css(...args)}
      }
    `;
  });

  return media;
};

export const media = getMediaBreakpoints();



// WEBPACK FOOTER //
// ./src/utils/style-utils.js